export default __webpack_public_path__ + "static/media/bp-21.16742651.jpg";